import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CompareDateService {

  constructor() { }

  compareTwoDate(dateStart, dateEnd): number {
    return (Math.floor((Date.UTC(dateStart.getFullYear(), dateStart.getMonth(), dateStart.getDate()) - Date.UTC(dateEnd.getFullYear(), dateEnd.getMonth(), dateEnd.getDate())) / (1000 * 60 * 60 * 24))) * -1;
  }
}
